// wrapping modes
export const ClampToEdgeWrapping = 1001;

//Filters
export const LinearFilter = 1006;
export const NearestFilter = 1007;
export const LinearMipMapLinearFilter = 1008;

//Data types
export const UnsignedByteType = 1009;
export const FloatType = 1010;

//Pixel formats
export const RGBAFormat = 1021;
export const RFormat = 1022;
export const R32Format = 1023;